import ng from 'angular';

export class InputChavePixController implements ng.IController {
  static $inject = ['$element'];
  tipo: number;
  ngModel: string;
  ngDisabled?: boolean;
  ngRequired?: boolean;
  ngChange?: () => void;
  formRef: angular.IFormController;

  constructor(private $element: JQLite) {}

}
